import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectStencilsData } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { changeParameter } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import { validator } from 'shared/product_tabs/tab_stencils/slice/validator';

import ProductDescription from 'shared/product_tabs/tab_stencils/components/ProductDescription';
import StencilItem from 'shared/product_tabs/tab_stencils/components/StencilItem';
import StencilType from 'shared/product_tabs/tab_stencils/components/StencilType';
import StencilsSide from 'shared/product_tabs/tab_stencils/components/StencilSide';
import GroupParameters from 'shared/product_tabs/tab_stencils/components/GroupParameters';

const Stencils = () => {
  const dispatch = useDispatch();

  const { stencils } = useSelector(selectStencilsData);

  const onChangeParameter = (name, value, ref) => {
    dispatch(changeParameter({ name, value, ref }));
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <ProductDescription />
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="stencil-type">
            <StencilType />
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="stencil-side">
            <StencilsSide />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <GroupParameters />
        </div>
      </div>
      {stencils?.map((productItem, i) => (
        <StencilItem
          key={i}
          reference={i}
          onChangeParameter={(name, value) => onChangeParameter(name, value, i)}
          productItem={productItem}
          validator={validator} />
      ))}
    </div>
  );
};

export default Stencils;
